/**
 * 测试环境快速填充工具
 * 用于开发测试时快速生成答案
 * 支持AYP测试(40题5级评分)
 */

/**
 * 根据人格类型生成匹配的答案(AYP测试)
 * @param {string} personalityType - 人格类型 ('极度年上型', '偏年上型', '平衡型', '偏年下型', '极度年下型')
 * @returns {Array} 答案数组 [1, 2, 3, ..., 5] 长度40
 */
export function generateAnswersForPersonality(personalityType) {
  // 预设的人格类型对应的维度倾向
  const personalityProfiles = {
    '极度年上型': {
      maturityPreference: 5,    // 成熟偏好高
      careNeed: 5,              // 照顾需求高
      guidanceDesire: 5,        // 引导欲望高
      independence: 1           // 独立倾向低
    },
    '偏年上型': {
      maturityPreference: 4,
      careNeed: 4,
      guidanceDesire: 4,
      independence: 2
    },
    '平衡型': {
      maturityPreference: 3,
      careNeed: 3,
      guidanceDesire: 3,
      independence: 3
    },
    '偏年下型': {
      maturityPreference: 2,
      careNeed: 2,
      guidanceDesire: 2,
      independence: 4
    },
    '极度年下型': {
      maturityPreference: 1,
      careNeed: 1,
      guidanceDesire: 1,
      independence: 5
    }
  }

  const profile = personalityProfiles[personalityType]
  if (!profile) {
    throw new Error(`未找到人格类型: ${personalityType}`)
  }

  const answers = []
  
  // 每个维度10题,共40题
  const dimensions = [
    'maturityPreference',
    'careNeed',
    'guidanceDesire',
    'independence'
  ]

  dimensions.forEach(dimension => {
    const baseScore = profile[dimension]
    // 每个维度10题,加入一些随机变化
    for (let i = 0; i < 10; i++) {
      // 在基础分数±1范围内随机
      const variation = Math.random() > 0.5 ? (Math.random() > 0.7 ? 1 : 0) : (Math.random() > 0.7 ? -1 : 0)
      const score = Math.max(1, Math.min(5, baseScore + variation))
      answers.push(score)
    }
  })

  return answers
}

/**
 * 快速填充所有答案为指定评分(AYP测试)
 * @param {number} rating - 评分 (1-5)
 * @returns {Array} 答案数组
 */
export function generateAnswersForRating(rating) {
  if (rating < 1 || rating > 5) {
    throw new Error(`无效的评分: ${rating}`)
  }
  
  const answers = []
  for (let i = 0; i < 40; i++) {
    answers.push(rating)
  }
  
  return answers
}

/**
 * 生成随机答案(AYP测试)
 * @returns {Array} 答案数组
 */
export function generateRandomAnswers() {
  const answers = []
  for (let i = 0; i < 40; i++) {
    answers.push(Math.floor(Math.random() * 5) + 1) // 1-5随机
  }
  return answers
}

/**
 * 获取所有人格类型列表
 * @returns {Array} 人格类型列表
 */
export function getAllPersonalityTypes() {
  return [
    '极度年上型',
    '偏年上型',
    '平衡型',
    '偏年下型',
    '极度年下型'
  ]
}

/**
 * 获取人格类型的表情符号
 * @param {string} personalityType - 人格类型
 * @returns {string} 表情符号
 */
export function getPersonalityEmoji(personalityType) {
  const emojiMap = {
    '极度年上型': '🐣',
    '偏年上型': '🌸',
    '平衡型': '⚖️',
    '偏年下型': '🌟',
    '极度年下型': '👑'
  }
  return emojiMap[personalityType] || '💕'
}
